<!--
 * @Author: your name
 * @Date: 2021-03-24 10:46:25
 * @LastEditTime: 2021-04-09 19:13:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zmbiz-mobile-work-front/src/pages/interviewnew/components/interViewResult.vue
-->
<template>
  <div>
    <van-popup
      v-model="interViewResultPopup"
      get-container="body"
      position="right"
      closeable
    >
      <div style="height: 100vh; width: 100vw">
        <div class="interviewInfo">
          <span>面试反馈</span>
          <div class="btn-group">
            <div
              class="btn"
              :class="{ isPass: item.value == reultParam.interviewResult }"
              @click="resulrHandleCheck(item)"
              v-for="(item, index) in btnList"
              :key="index"
            >
              {{ item.label }}
            </div>
          </div>
          <van-cell-group>
            <van-field
              v-model="reultParam.interviewEvaluate"
              rows="8"
              type="textarea"
              maxlength="1000"
              :placeholder="
                reultParam.interviewResult == 2
                  ? '必须填写淘汰原因'
                  : '最多写1000个字哦'
              "
            />
          </van-cell-group>
          <div
            class="submit"
            :style="
              interviewResultLoding ? 'pointer-events: none;opacity: 0.5;' : ''
            "
            @click="handleSubmit"
            v-if="!interViewResultObj.interviewFinalResult"
          >
            提交面试结果
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { addInterviewEvaluate } from '../../../api/interview';
import { Popup, Toast, Field } from 'vant';

Vue.use(Popup).use(Toast).use(Field);

export default {
  data() {
    return {
      // 面试结果
      interViewResultPopup: false,
      btnList: [
        { label: '通过', value: 1, isPass: false },
        { label: '淘汰', value: 2, isPass: false },
      ],
      interViewResultObj: {},
      interviewResultLoding: false,
      reultParam: {
        id: '',
        interviewEvaluate: '',
        interviewResult: '',
      },
    };
  },
  methods: {
    init(val) {
      this.interViewResultObj = val;
      this.interViewResultPopup = true;
      this.reultParam.interviewResult = val.interviewResult || '';
      this.reultParam.interviewEvaluate = val.interviewEvaluate || '';
      this.reultParam.id = val.id;
    },

    // 面试结果
    resulrHandleCheck(item) {
      if (this.interViewResultObj.interviewFinalResult) return;
      this.reultParam.interviewResult = item.value;
    },

    handleSubmit() {
      if (!this.reultParam.interviewResult) return this.$toast('请选择面试结果');
      if (!this.reultParam.interviewEvaluate) return this.$toast('请填写面试评价');
      this.interviewResultLoding = true;
      addInterviewEvaluate(this.reultParam)
        .then((res) => {
          Toast('提交面试结果成功');
          this.interviewResultLoding = false;
          this.$emit('callback');
          this.interViewResultPopup = false;
        })
        .catch((err) => {
          Toast(err || '提交失败 请稍后再试');
        });
    },
  },
};
</script>

<style lang="scss">
.interviewInfo {
  font-size: 28px;
  padding: 30px 0;
  > span {
    padding: 20px 40px;
    color: #000;
    font-size: 30px;
    font-weight: 800;
  }
  .btn-group {
    padding: 40px;
    display: flex;
    .btn {
      display: block;
      border: 2px solid #f1524a;
      border-radius: 36px;
      padding: 8px 20px;
      min-width: 120px;
      color: #f1524a;
      font-size: 26px;
      text-align: center;
      line-height: 40px;
      &:first-child {
        margin-right: 30px;
      }
      &.isPass {
        color: #eee;
        background: rgba(255, 255, 255, 1)
          linear-gradient(
            270deg,
            rgba(255, 135, 28, 1) 0%,
            rgba(239, 76, 79, 1) 100%
          );
      }
    }
  }
  .van-cell {
    background: rgba(248, 248, 248, 1);
  }
  .submit {
    color: #eee;
    margin: 60px 40px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    background: rgba(255, 255, 255, 1)
      linear-gradient(
        270deg,
        rgba(255, 135, 28, 1) 0%,
        rgba(239, 76, 79, 1) 100%
      );
    border-radius: 50px;
    font-size: 36px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.2);
  }
}
</style>